module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro@2-4c7251a6d8a130997cba106aa3a04d9e.jpg";